//—— 影片網址 ——
//
//  所有 public/videos/ 底下的影片都要經過這裡，不要自己串路徑。
//
//  —— 為什麼要帶版本參數 ——
//
//  Cloud Run（Buildpacks）給靜態檔的 ETag 形如
//      W/"<檔案大小的十六進位>-<修改時間>"
//  而修改時間被釘死在 1980-01-01，**每一個檔案都一樣**（實測線上五支影片
//  的 ETag 後半段全是 49773873e8）。所以那個 ETag 等於只看檔案大小。
//
//  偏偏修影片最常用的兩招都不改檔案大小：
//      改 H.264 的 level 標籤（不重編，畫質零損失）
//      把 moov 搬到 mdat 前面（faststart）並修 chunk offset
//
//  結果是：壞掉的那一份跟修好的那一份，ETag 一模一樣。
//  `cache-control: public, no-cache` 會強制瀏覽器每次都去問，但問到的是
//  **304 Not Modified** —— 它就繼續用手上那份壞的，而且永遠不會更新。
//  實測：帶舊 ETag 去 If-None-Match 回 304，帶假的回 200。
//
//  真實踩過的症狀：緋紅第一幕在 iPhone 上整片黑、聲音照播 ——
//  那是 feihong-1 曾經是 H.264 Level 6.0（超過 Apple 硬體解碼上限 5.2），
//  檔案早就換成 5.1 了，但手機上那份換不掉。
//
//  ⚠️ **換掉任何一支影片的內容（檔名不變）時，把 V 加一。**
//  這是唯一能讓已經抓過的裝置拿到新檔的辦法 —— 換網址才會是新的快取項目。
//  檔名有變的話不用動它。
//  V 的沿革（每一次都是「內容換了但檔名沒變」）：
//    1 → 2  feihong-1 的 H.264 level 從 6.0 改成 5.1（iPhone 整片黑）
//    2 → 3  feihong-loading 搬 moov 做 faststart（2026-11-02）
const V = 3;

//  用 PUBLIC_URL 而不是寫死 "/"：CRA 的 homepage 設定改掉時才不會整批失效。
export const videoUrl = (file) =>
  `${process.env.PUBLIC_URL}/videos/${file}?v=${V}`;

export default videoUrl;
